/**
 * D1's `datetime('now')` default returns "YYYY-MM-DD HH:MM:SS" (space-separated,
 * no timezone marker) representing UTC. Most JS engines parse that exact shape
 * as LOCAL time instead of UTC, which silently shifts every timestamp by the
 * viewer's UTC offset (e.g. "hace -360m" for someone in UTC-6). Normalize to
 * unambiguous ISO 8601 UTC before handing it to `Date`.
 */
export function parseUtcDate(value: string): Date {
  const hasTimezone = /[zZ]|[+-]\d\d:\d\d$/.test(value);
  const normalized = hasTimezone ? value : `${value.replace(" ", "T")}Z`;
  return new Date(normalized);
}

export function relTime(iso: string): string {
  const diff = Math.max(0, Date.now() - parseUtcDate(iso).getTime());
  const m = Math.floor(diff / 60000);
  if (m < 1)  return "justo ahora";
  if (m < 60) return `hace ${m}m`;
  const h = Math.floor(m / 60);
  if (h < 24) return `hace ${h}h`;
  const d = Math.floor(h / 24);
  if (d < 30) return `hace ${d}d`;
  return `hace ${Math.floor(d / 30)}mes`;
}
